import { useParams } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';

import Page from '@/components/layout/Page';
import { Card, CardContent } from '@/components/ui/card';
import Header from '@/components/layout/Header';
import Loader from '@/components/common/Loader';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getUserInitials } from '@/helpers/stringHelpers';

import BookingTitleAndTime from './components/common/BookingTitleAndTime';
import MeetingLocation from './components/common/MeetingLocation';
import BookingDetails from './components/common/BookingDetails';
import NotesCard from './components/coachBookingViewPage/NotesCard';

import { useBooking } from '@/data/booking';

const CoachBookingViewPage = () => {
  const params = useParams();
  const booking = useBooking(params.id);

  if (booking.isLoading && !booking.data) {
    return (
      <Page>
        <div className="flex justify-center items-center h-[calc(100vh-50px)]">
          <Loader />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <Header title="Booking Details" backTo="/booking" />
      <div className="space-y-4">
        <BookingTitleAndTime booking={booking.data} />
        <Card asChild>
          {/* <Link to={`/conversation/${booking.data.conversation.id}`}> */}
          <CardContent className="p-4">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <Avatar className="h-14 w-14">
                  <AvatarImage
                    src={`/avatars/placeholder.jpg`}
                    alt={booking.data.user?.firstname}
                  />
                  <AvatarFallback>
                    {getUserInitials(booking.data.user)}
                  </AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="text-lg">
                    {booking.data.user?.firstname} {booking.data.user?.lastname}
                  </h3>
                  <span className="text-sm text-muted-foreground">
                    Customer
                  </span>
                </div>
              </div>
              <div>
                <MessageSquare className="w-6 h-6" />
              </div>
            </div>
          </CardContent>
          {/* </Link> */}
        </Card>

        <NotesCard />
        <MeetingLocation booking={booking.data} />
        <BookingDetails booking={booking.data} />
        <div className="h-20"></div>
      </div>
    </Page>
  );
};

export default CoachBookingViewPage;
